
  import React from "react"
  import Component from "/Users/mathurah/Documents/Development/my-app/src/layouts/index.js"
  import data from "/Users/mathurah/Documents/Development/my-app/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js